import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deskimoDayOfficeFilterDataSelector,
  deskimoDayOfficeListSelector,
} from "../../../../selectors/PropertySelector";
import TableCustom from "../../../../../../components/Table";
import Action from "../../../PropertyDetail/Components/DayOfficeTab/components/ActionsButton";
import ModalCreateEditOffice from "../../../PropertyDetail/Components/DayOfficeTab/components/ModalCreateEditOffice";
import CheckboxCustom from "../../../../../../components/Checkbox";
import { deskimoDayOfficeExportAction } from "../../../../actions/PropertyActions";
import { deskimoDayOfficeExportSelectedSelector } from "../../../../selectors/PropertySelector";

type Props = {
  loading: boolean;
  onChangeSortCol: any;
  onChangePagination: any;
  refreshList: any;
  setRefreshList: any;
  checkAll: any;
  setCheckAll: any;
};
const DAY_BOOK_IS_AVAILABLE = 1;
const DAY_BOOK_IS_UNAVAILABLE = 0;

const OfficeList = ({
  loading,
  onChangeSortCol,
  onChangePagination,
  refreshList,
  setRefreshList,
}: Props) => {
  const [checkAll, setCheckAll] = useState(false);
  const dayOfficeList = useSelector(deskimoDayOfficeListSelector);
  const dayOfficeFilterData = useSelector(deskimoDayOfficeFilterDataSelector);
  const listDayOfficeExport = useSelector(
    deskimoDayOfficeExportSelectedSelector
  );
  const dispatch = useDispatch();

  const columns = [
    {
      key: "",
      col: (
        <CheckboxCustom
          checked={checkAll}
          onChange={(e, data: any) => {
            setCheckAll(data.checked);
            if (data.checked) {
              dispatch(
                deskimoDayOfficeExportAction(
                  dayOfficeList.day_offices.map((office: any) => office.id)
                )
              );
            } else {
              dispatch(deskimoDayOfficeExportAction([]));
            }
          }}
        />
      ),
    },
    { key: "name", col: "Office Name" },
    { key: "company", col: "Property Company" },
    { key: "workspace", col: "Workspace" },
    { key: "market", col: "Market" },
    { key: "capacity", col: "Capacity (people)" },
    { key: "availableForDayBook", col: "Available for Daily Book" },
    { key: "hourlyRate", col: "Hourly Rate" },
    { key: "dailyRate", col: "Daily Rate" },
    { key: "monthlyRate", col: "Monthly Rate" },
    { key: "status", col: "Status" },
    { key: null, col: "Actions" },
  ];

  const getDailyBookingStatus = (
    officeBookingStatus: number | null | undefined
  ) => {
    switch (officeBookingStatus) {
      case DAY_BOOK_IS_AVAILABLE:
        return "Available";
      case DAY_BOOK_IS_UNAVAILABLE:
        return "Unavailable";
      default:
        return "N/A";
    }
  };
  const handleCheckExportDayOffice = (checked: any, officeId: any) => {
    if (checked) {
      const newListExport = [...listDayOfficeExport, officeId];
      dispatch(deskimoDayOfficeExportAction(newListExport));
    } else {
      const newListExport = [...listDayOfficeExport].filter(
        (item) => item !== officeId
      );
      dispatch(deskimoDayOfficeExportAction(newListExport));
    }
  };

  const decorateTableData = () => {
    if (dayOfficeList?.day_offices && dayOfficeList?.day_offices?.length > 0) {
      return dayOfficeList.day_offices.map((office: any) => {
        return {
          col1: (
            <CheckboxCustom
              onChange={(e, data) =>
                handleCheckExportDayOffice(data.checked, office?.id)
              }
              checked={listDayOfficeExport.includes(office?.id)}
            />
          ),
          col2: office?.name,
          col3: office?.company_name,
          col4: office?.property_name,
          col5: office?.market,
          col6: office?.capacity,
          col7: getDailyBookingStatus(office?.is_available_for_daily_booking),
          col8: office?.hourly_rate
            ? `${office?.currency} ${office?.hourly_rate}`
            : "-",
          col9: office?.daily_rate
            ? `${office?.currency} ${office?.daily_rate}`
            : "-",
          col10: office?.monthly_rate
            ? `${office?.currency} ${office?.monthly_rate}`
            : "-",
          col11: (
            <div>
              <div>{office?.status_name}</div>
            </div>
          ),
          col12: (
            <Action
              visibilityAction={office?.visibility_action}
              visibility={office?.visibility}
              propertyId={office?.property_id}
              companyId={office?.company_id}
              id={office?.id}
              status={office?.status}
              onRefresh={() => setRefreshList(!refreshList)}
            />
          ),
        };
      });
    }

    return [];
  };

  return (
    <div>
      <TableCustom
        tableClass="table-private-office"
        tableLayoutFixed
        noHeader={false}
        loading={loading}
        showTotal
        tableData={decorateTableData()}
        sortTable
        onChangeSortCol={onChangeSortCol}
        sortBy={dayOfficeFilterData.sort_by}
        orderBy={dayOfficeFilterData.order_by}
        columns={columns}
        currentPage={dayOfficeFilterData?.page}
        totalItems={dayOfficeList?.pagination?.total}
        itemPerPage={dayOfficeList?.pagination?.limit}
        unit="day offices"
        onChangePagination={onChangePagination}
      />
      <ModalCreateEditOffice onRefresh={() => setRefreshList(!refreshList)} />
    </div>
  );
};

export default OfficeList;
